import { BusinessInfo, TimezoneType } from '@wix/bookings-uou-types';
import { getUoULocale } from '../domain/locale';
import { BasedOn, GetBookingsSettingsResponse } from '@wix/ambassador-bookings-v2-bookings-settings/types';

export enum BusinessPropertyName {
  CANCELLATION_POLICY = 'cancellationPolicy',
  DEFAULT_TIMEZONE_PROPERTY_NAME = 'defaultTimezone',
  CLIENT_CAN_CHANGE_TIMEZONE = 'clientCanChangeTimezone',
  MULTI_SERVICES_APPOINTMENTS_PROPERTY_NAME = 'isMultiServicesAppointmentsEnable',
}

export const mapResponseToBusinessInfo = (
  bookingsSettingsResponse?: GetBookingsSettingsResponse,
): BusinessInfo | undefined => {
  const bookingsSettings = bookingsSettingsResponse?.bookingsSettings;
  if (!bookingsSettings?.siteProperties) {
    return;
  }
  const {
    businessName,
    phone,
    email,
    language,
    paymentCurrency,
    address,
    timeZone,
    locale,
  } = bookingsSettings.siteProperties;
  const clientCanChangeTimezone =
    bookingsSettings?.displayTimeZone?.customerCanChange ?? true;

  const defaultTimezone =
    bookingsSettings?.displayTimeZone?.basedOn === BasedOn.CUSTOMER_TIME_ZONE
      ? TimezoneType.CLIENT
      : TimezoneType.BUSINESS;

  return {
    name: businessName || '',
    phone: phone || '',
    email: email || '',
    language: getUoULocale(language),
    currency: paymentCurrency || '',
    address: address?.googleFormattedAddress || '',
    timeZone: timeZone || '',
    dateRegionalSettingsLocale: formatDateRegionalSettingsLocale(
      language || '',
      locale?.country || '',
    ),
    timezoneProperties: {
      clientCanChooseTimezone: clientCanChangeTimezone,
      defaultTimezone,
    },
  };
};

export function formatDateRegionalSettingsLocale(language, countryCode) {
  const locale = language?.split('-')[0];
  return `${locale}${countryCode ? `-${countryCode}` : ``}`;
}

export function getPropertyValue(properties, propertyName) {
  const property = properties?.find(
    (businessProperty) => businessProperty.propertyName === propertyName,
  );
  return property?.value;
}
